import React, { useEffect, useState } from 'react';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from '../Sheet';
import { AlertTriangle, AlertCircle, Info, ShieldAlert, CheckCheck, Bell, Settings } from 'lucide-react';
import { Button } from '../Button';
import { Badge } from '../Badge';
import { toast } from 'sonner';
import { mockApi } from '../../lib/mockApi';
const iconMap: Record<string, any> = {
  'Threat Intel': AlertTriangle,
  'Bot Detection': AlertCircle,
  'Visit Intel': ShieldAlert,
  Sentiment: Info
};
export function NotificationsSheet({
  open,
  onOpenChange
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  const [notifs, setNotifs] = useState<any[]>([]);
  useEffect(() => {
    const loadData = async () => {
      const data = await mockApi.getNotifications();
      setNotifs(data);
    };
    if (open) loadData();
    return mockApi.subscribe(loadData);
  }, [open]);
  const unreadCount = notifs.filter(n => !n.read).length;
  const handleMarkRead = (id: number) => {
    mockApi.markNotificationRead(id);
  };
  const handleMarkAllRead = () => {
    mockApi.markAllNotificationsRead();
    toast.success('Semua notifikasi ditandai sudah dibaca');
  };
  return <Sheet open={open} onOpenChange={onOpenChange} data-id="element-736">
      <SheetContent className="w-full sm:max-w-md p-0 flex flex-col border-l border-border/60 bg-background/95 backdrop-blur" data-id="element-737">
        <SheetHeader className="px-6 py-5 border-b border-border/60" data-id="element-738">
          <div className="flex items-center gap-2 mb-1" data-id="element-739">
            <div className="size-7 rounded-md bg-primary/10 border border-primary/20 flex items-center justify-center" data-id="element-740">
              <Bell className="size-3.5 text-primary" data-id="element-741" />
            </div>
            <span className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground" data-id="element-742">
              Inbox
            </span>
            <Badge className="bg-red-50 text-red-700 border-red-200 font-mono text-[9px] ml-auto" data-id="element-743">
              {unreadCount} BARU
            </Badge>
          </div>
          <SheetTitle className="text-lg" data-id="element-744">Notifikasi</SheetTitle>
          <SheetDescription className="text-xs" data-id="element-745">
            Anda memiliki {unreadCount} notifikasi baru.
          </SheetDescription>
          {unreadCount > 0 && <button onClick={handleMarkAllRead} className="text-[10px] font-mono uppercase text-primary hover:underline flex items-center gap-1" data-id="element-746">
              <CheckCheck className="size-3" data-id="element-747" /> Tandai Semua
            </button>}
        </SheetHeader>

        <div className="flex-1 overflow-y-auto p-4 space-y-3 scrollbar-thin scrollbar-thumb-border scrollbar-track-transparent" data-id="element-748">
          {notifs.map(n => {
          const Icon = iconMap[n.category] || Info;
          return <div key={n.id} className={`relative p-4 rounded-lg border transition cursor-pointer group ${n.read ? 'bg-card border-border/40 opacity-70' : 'bg-muted/20 border-border/80 hover:border-primary/40'}`} onClick={() => !n.read && handleMarkRead(n.id)} data-id="element-749">
                {!n.read && <div className="absolute top-4 right-4 size-2 rounded-full bg-primary animate-pulse" data-id="element-750" />}
                <div className="flex items-start gap-3" data-id="element-751">
                  <div className={`mt-0.5 flex size-8 items-center justify-center rounded-md border shrink-0 ${n.sev === 'KRITIS' ? 'bg-red-500/10 border-red-500/20 text-red-500' : n.sev === 'TINGGI' ? 'bg-amber-500/10 border-amber-500/20 text-amber-500' : n.sev === 'SEDANG' ? 'bg-blue-500/10 border-blue-500/20 text-blue-500' : 'bg-muted border-border/50 text-muted-foreground'}`} data-id="element-752">
                    <Icon className="size-4" data-id="element-753" />
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-754">
                    <div className="flex items-center gap-2 mb-1" data-id="element-755">
                      <Badge variant="outline" className={`font-mono text-[8px] px-1 py-0 h-4 border-none ${n.sev === 'KRITIS' ? 'bg-red-500/10 text-red-500' : n.sev === 'TINGGI' ? 'bg-amber-500/10 text-amber-500' : n.sev === 'SEDANG' ? 'bg-blue-500/10 text-blue-500' : 'bg-muted text-muted-foreground'}`} data-id="element-756">
                        {n.sev}
                      </Badge>
                      <span className="font-mono text-[9px] text-muted-foreground" data-id="element-757">
                        {n.time}
                      </span>
                    </div>
                    <p className={`text-sm font-bold leading-tight mb-1 ${n.read ? 'text-foreground/80' : 'text-foreground'}`} data-id="element-758">
                      {n.title}
                    </p>
                    <p className="text-xs text-muted-foreground leading-relaxed" data-id="element-759">
                      {n.body}
                    </p>
                  </div>
                </div>
              </div>;
        })}
        </div>

        <div className="p-4 border-t border-border/60 bg-muted/10" data-id="element-760">
          <div className="flex items-center justify-between" data-id="element-761">
            <Button variant="ghost" size="sm" onClick={() => toast.info('Membuka pengaturan notifikasi')} className="font-mono text-[10px] gap-1" data-id="element-762">
              <Settings className="size-3" data-id="element-763" /> Preferensi
            </Button>
            <span className="font-mono text-[10px] text-muted-foreground" data-id="element-764">
              Sinkron · {new Date().toLocaleTimeString('id-ID')}
            </span>
          </div>
        </div>
      </SheetContent>
    </Sheet>;
}